import store from 'store2';

const storageKey = 'currentEnterpriseId';
/**
 * A utility for setting and restoring a current enterpriseId.
 */
export const EnterpriseIdStorageService = {
    get: () => store.get(storageKey),
    set: (enterpriseId: string | null | undefined) => store.set(storageKey, enterpriseId),
    clear: () => store.remove(storageKey),
};
